import { Time } from '~/constants/variables';

const pad = (value: number): string => String(value).padStart(2, '0');

export const formatPromoCountdown = (
  remainingMs: number,
): { days: number } | { clock: string } => {
  if (remainingMs >= Time.Day) {
    return { days: Math.floor(remainingMs / Time.Day) };
  }

  const totalSeconds = Math.floor(remainingMs / Time.Second);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { clock: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}` };
};
